import { vservice } from '@niknevis/vue-modules'
import { PanelInvoiceService } from '@/modules/invoice/services/panel-invoice.service'
import { PaymentLinkRequest, StartPaymentResource } from '@/modules/transaction/models/payment.model'
import { BasePaymentlinkUseCase } from '@/modules/transaction/use-cases/shared/base-paymentlink.use-case'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'

@vservice()
export class InvoiceGetPaymentResourceUseCase extends BasePaymentlinkUseCase
  implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: PanelInvoiceService
  ) {
    super()
  }

  isLoading = false

  execute(id: number, data: PaymentLinkRequest): Promise<void | StartPaymentResource> {
    this.isLoading = true
    return this.service.paymentLink(id, this.requestData(data)).then((res) => {
      this.isLoading = false
      return res.data
    }).catch((err) => {
      this.isLoading = false
    })
  }

}
